import { usePayrollUIConfig } from "../../../hooks/usePayrollUIConfig";

import TunisiaPayrollForm from "./tunisia/TunisiaPayrollForm";
import MoroccoPayrollForm from "./morocco/MoroccoPayrollForm";
import FrancePayrollForm from "./france/FrancePayrollForm";
import QatarPayrollForm from "./qatar/QatarPayrollForm";
import SaudiPayrollForm from "./saudi/SaudiPayrollForm";

const CountrySpecificForm = ({ formType, ...props }) => {
  const { config, loading, error } = usePayrollUIConfig();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  const countryCode = (!error && config) ? config.countryCode : "TN";

  switch (countryCode) {
    case "TN": return <TunisiaPayrollForm {...props} />;
    case "MA": return <MoroccoPayrollForm {...props} />;
    case "FR": return <FrancePayrollForm {...props} />;
    case "QA": return <QatarPayrollForm {...props} />;
    case "SA": return <SaudiPayrollForm {...props} />;
    default:   return <TunisiaPayrollForm {...props} />;
  }
};

export default CountrySpecificForm;
